"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderRequestsColumns = void 0;
function OrderRequestsColumns(catalogColumnKey, catalogColumnName, etikColumnKey, etikColumnName) {
    return [
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            width: 300,
            minWidth: 300,
            type: 'derivedColumn',
        },
        {
            field: 'tb',
            editable: false,
            headerName: 'Tb',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'pg',
            editable: false,
            headerName: 'PG',
            maxWidth: 75,
            type: 'derivedColumn',
        },
        {
            field: 'minimum_quantity',
            editable: false,
            headerName: 'Min.bestellmenge',
            type: 'derivedColumn',
        },
        {
            field: catalogColumnKey,
            headerName: catalogColumnName,
            editable: false,
            type: ['booleanColumn', 'derivedColumn'],
        },
        {
            field: 'requested_quantity',
            editable: true,
            headerName: 'Bestellmenge',
        },
        {
            field: 'joint_cumulative_quantity',
            editable: false,
            headerName: 'Kumulierte Bestellmenge',
            type: 'derivedColumn',
        },
        {
            // expected quantity of labels that are ordered and not fulfilled
            field: 'open_order_quantity',
            editable: false,
            headerName: 'Offene Bestell.',
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: 'inventory_quantity',
            editable: false,
            headerName: 'Lagermenge',
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: 'ean',
            headerName: 'EAN',
            editable: false,
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: 'interne_art_nr',
            headerName: 'Interne Art.-Nr.',
            editable: false,
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: 'be_art_nr',
            headerName: 'BE-Art.-Nr.',
            editable: false,
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: 'floramedia_art_nr',
            headerName: 'FAN',
            headerTooltip: 'Floramedia Artikel Nummer',
            width: 100,
            type: 'derivedColumn',
        },
        {
            field: etikColumnKey,
            headerName: etikColumnName,
            editable: false,
            type: ['booleanColumn', 'derivedColumn'],
        },
    ];
}
exports.OrderRequestsColumns = OrderRequestsColumns;
